import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import PATHS, { mergePaths } from 'utils/paths';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import CreateInvoiceForm from '../Invoice/CreateInvoiceForm';
import NewRecordForm from '../NewRecords/NewRecordForm';

/**
 * @author @muhammedburakak
 */

const Invoices = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'invoice',
				path: mergePaths(PATHS.INVOICES, PATHS.INVOICE)
			},
			{
				label: 'invoiceDetails',
				path: mergePaths(PATHS.INVOICES, PATHS.INVOICE_DETAILS)
			},
			{
				label: 'newRecords',
				path: mergePaths(PATHS.INVOICES, PATHS.NEW_RECORDS)
			},
			{
				label: 'priceNotFoundOrders',
				path: mergePaths(PATHS.INVOICES, PATHS.PRICE_NOT_FOUND_ORDERS)
			},
			{
				label: 'notInvoicedOrders',
				path: mergePaths(PATHS.INVOICES, PATHS.NOT_INVOICED_ORDERS)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/manage-subscription-icon.json.gz"
				title="invoices">
				<Button
					icon={faPlus}
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					label="newRecord"
					onClick={() => NiceModal.show(NewRecordForm)}
					variant="blue"
					className="addButton"
				/>

				<Button
					icon={faPlus}
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
					label="createInvoice"
					onClick={() => NiceModal.show(CreateInvoiceForm)}
					variant="blue"
					className="addButton"
				/>
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default Invoices;
